// extracted by mini-css-extract-plugin
module.exports = {"disabledLegend":"ProfilesEnabled_disabledLegend__2CZhs","hiddenLegend":"ProfilesEnabled_hiddenLegend__6Kehl"};